export const Confirm = require('../../src/front/Applicants').ConfirmApplicant;
